<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h3>Vorlagen</h3>
</div>

<div class="table-responsive">
    <table class="table table-sm table-hover table-files">
        <thead>
        <tr>
            <th style="width: 95px"></th>
            <th style="width: 120px">Vorschau</th>
            <th>Typ</th>
            <th>Name</th>
            <th></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let file of files">
            <td>
                <button type="button" class="btn btn-danger btn-sm" placement="right" containerClass="auth-tooltip"
                        *ngIf="accessService.hasRights(Right.PMO)"
                        (click)="deleteOrRemoveFile(file)"
                        [tooltip]="templatesTemplate"
                        [delay]="500">
                    <i class="fa-solid fa-trash"></i>
                </button>
                <button type="button" class="btn btn-success btn-sm ms-2" (click)="getFileData(file)">
                    <i class="fa-solid fa-download"></i>
                </button>
            </td>
            <td>
                <ng-container *ngIf="file.type.startsWith('image')">
                    <img class="img-fluid" *ngIf="file.thumbnail" [src]="'data:' + file.type + ';base64,' + file.thumbnail">
                    <img class="img-fluid" *ngIf="file.data" [src]="file.data">
                </ng-container>
                <ng-container *ngIf="!file.type.startsWith('image')">
                    Nicht verfügbar
                </ng-container>
            </td>
            <td>
                {{ file.type | filetype }}
            </td>
            <td>
                {{ file.name }}
            </td>
        </tr>
        </tbody>
    </table>
</div>

<button type="button" class="btn btn-secondary btn-sm mb-3" placement="right" containerClass="auth-tooltip"
        *ngIf="accessService.hasRights(Right.PMO)"
        (click)="triggerFileInput()"
        [tooltip]="templatesTemplate"
        [delay]="500">Datei hochladen
</button>
<input type="file" #fileInput class="d-none" multiple (change)="handleInputChange($event)">

<p class="text-muted" *ngIf="files.length === 0">Keine Dateien vorhanden</p>

<div>
    <button type="button" class="btn btn-success" placement="right" containerClass="auth-tooltip"
            *ngIf="accessService.hasRights(Right.PMO)"
            (click)="update()"
            [tooltip]="templatesTemplate"
            [delay]="500">Speichern
    </button>
</div>

<ng-template #templatesTemplate><div [innerHtml]="accessService.authReason(null, 'EDIT_TEMPLATES')"></div></ng-template>
